<template lang="pug">
  div
    Header
    v-content
      router-view
</template>

<script>
export default {
  components: {
    Header: () => import('../../components/Header')
  }
}
</script>
